<template>
  <RevCheckbox
    v-if="offer.compliancy.isUserAgreementRequired"
    :id
    :disabled
    :model-value="offer.compliancy.isUserAgreementAccepted"
    @update:model-value="handleCheck"
  >
    <template #label>
      <div class="leading-[1]">
        <AnnuallyTerms
          v-if="offer.paymentFrequency === 'ANNUALLY'"
          :documents="offer.compliancy.documents"
        />
        <BienniallyTerms
          v-else-if="offer.paymentFrequency === 'BIANNUALLY'"
          :documents="offer.compliancy.documents"
        />
        <Terms v-else :documents="offer.compliancy.documents" />
      </div>
    </template>
  </RevCheckbox>

  <Terms v-else :documents="offer.compliancy.documents" />
</template>

<script setup lang="ts">
import type { InsuranceOffer } from '@backmarket/http-api'
import { RevCheckbox } from '@ds/components/Checkbox'

import AnnuallyTerms from './components/AnnuallyTerms/AnnuallyTerms.vue'
import BienniallyTerms from './components/BienniallyTerms/BienniallyTerms.vue'
import Terms from './components/Terms/Terms.vue'

const props = defineProps<{
  id: string
  offer: InsuranceOffer
  disabled: boolean
}>()

const emit = defineEmits<{
  update: [updatedInsurance: InsuranceOffer]
}>()

function handleCheck(isUserAgreementAccepted: boolean | string[]) {
  if (typeof isUserAgreementAccepted !== 'boolean') return

  emit('update', {
    ...props.offer,
    compliancy: { ...props.offer.compliancy, isUserAgreementAccepted },
  })
}
</script>
